export default __webpack_public_path__ + "static/media/horizontal.7564437e.png";